// 不需要校验token的接口
import {getCurrentLanguages} from "~/utils/I18nUtils";
import {useRuntimeConfig} from "nuxt/app";
import useSeoStore from "@/store/modules/seo"
import { storeToRefs } from "pinia"

const noTokenPath = {
   "/login": true,
   "/download": true,
   "/": true
}

const languageRoute = {
   "zh": true,
   "en": true,
   "ja": true,
   "tw": true,
   "ko": true,
   "hi": true,
   "ar": true,
   "de": true,
   "fr": true,
   "id": true,
   "itb": true,
   "uk": true
}
export default defineNuxtRouteMiddleware((to, from)=>{
   // 拦截路径中包含 undefined 的路由（不包括查询参数）
   if (to.path && to.path.includes('/undefined')) {
      console.warn('[Middleware] 检测到无效路径:', to.path)
      return navigateTo('/')
   }

   if (to.fullPath) {
      initClientSEO(to.fullPath)
   }
   // if (to.params._lang && languageRoute[String(to.params._lang)]) {
   //    // useCookie('lang').value = String(to.params._lang)
   //    createCrossDomainCookie('lang', String(to.params._lang))
   //    console.log("langs===111", useCookie('lang').value)
   //    return ;
   // }
   // let lang = getCurrentLanguages()
   
   // let router = useRouter()
   // // 增加处理，如果直接访问路由以 / 结尾 ，则去掉 /再访问，否则nuxt3 的路由规则会找不当前页面
   // if (to.fullPath.endsWith('/') && to.fullPath.length > 1) {
   //    to.path = to.path.slice(0, -1)
   // }
   // let pathToName =  "_lang" + (to.path == "/" ? "-index" : to.path.replace(/\//g, "-"))
   // console.log("pathToName===", to.path, to.fullPath)
  
   // return navigateTo(`/${to.fullPath}`);
   // if (router.hasRoute(pathToName)) {
   //       // 如果to.fullPath是/并且to.query不为空且to.query.code有值和to.query.state为“linuxdo”，重定向到login/loginResult页面，并且把code和state作为query参数
   //       if (to.path == "/" && to.query && to.query.code && to.query.state == "linuxdo") {
   //          return navigateTo(`/${lang}/login/loginResult?code=${to.query.code}&state=${to.query.state}`)
   //       }
         
   //    return navigateTo(`/${lang}${to.fullPath}`)
   // } else {
   //    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
   // }
})

export function initClientSEO(path: string) {
   let configMap = storeToRefs(useSeoStore()).seoConfig.value
   const [pathPart, queryPart] = path.split('?')
   let pathWithoutLang = pathPart
   
   // 循环去除所有可能的语言前缀，直到没有更多匹配
   // 这样可以处理 /zh/zh/home 或 /zh/en/home 等情况
   let previousPath = ''
   while (previousPath !== pathWithoutLang) {
      previousPath = pathWithoutLang
      // 匹配 /xx/ 格式（有后面的斜杠）
      const langPrefixMatch = pathWithoutLang.match(/^\/([a-z]{2})\//)
      if (langPrefixMatch && languageRoute[langPrefixMatch[1]]) {
         pathWithoutLang = pathWithoutLang.replace(/^\/([a-z]{2})\//, '/')
      } else {
         // 匹配 /xx 格式（没有后面的斜杠），也去除
         const langPrefixMatch2 = pathWithoutLang.match(/^\/([a-z]{2})$/)
         if (langPrefixMatch2 && languageRoute[langPrefixMatch2[1]]) {
            pathWithoutLang = pathWithoutLang.replace(/^\/([a-z]{2})$/, '/')
         }
      }
   }

   console.log('pathWithoutLang=====>>', pathWithoutLang)
   const lang = getCurrentLanguages()
   const currentSeo = configMap[pathWithoutLang]
   const config = currentSeo ? currentSeo[lang] : {}
   const baseURL = useRuntimeConfig().public.pdfOneUrl
   // 构建路径部分，确保格式正确（包含查询参数）
   // 防御性检查：避免 undefined 字符串出现在路径中
   const finalPathPart = (pathWithoutLang === '/' || !pathWithoutLang || pathWithoutLang.includes('undefined')) ? '' : pathWithoutLang
   const pathWithQuery = queryPart ? `${finalPathPart}?${queryPart}` : finalPathPart

   // console.log('config=====>>', apiUrl, lang, path, pathWithoutLang)
   // Apply head tags
   useHead({
     title: (config && config.title) || 'PDF One',
     meta: [
       { name: 'description', content: (config && config.description) || '' },
       { property: 'og:title', content: (config && config.title) || 'PDF编辑王 - 扫描件也能免费编辑' },
       { property: 'og:description', content: (config && config.description) || '提供免费OCR识别，无需登录。文件SSL加密传输，12小时自动销毁。' },
       { property: 'og:type', content: 'website' },
       { property: 'og:url', content: `${baseURL}${lang}${pathWithQuery}` },
       // 专用社交分享图（1200×630），提升社交平台分享 CTR
       { property: 'og:image', content: `${baseURL}assets/images/og-image.png` },
       { property: 'og:image:width', content: '1200' },
       { property: 'og:image:height', content: '630' },
       { property: 'og:image:type', content: 'image/png' },
       // Twitter Card：Twitter 优先读自己的标签，确保分享时显示大图卡片
       { name: 'twitter:card', content: 'summary_large_image' },
       { name: 'twitter:title', content: (config && config.title) || 'PDF One' },
       { name: 'twitter:description', content: (config && config.description) || '' },
       { name: 'twitter:image', content: `${baseURL}assets/images/og-image.png` },
     ],
     link: [
      { rel: 'canonical', href: `${baseURL}${lang}${pathWithQuery}` },
      // ── 当前激活语言（与 nuxt.config.ts i18n.locales 保持同步）─────────
      { rel: 'alternate', hreflang: 'zh', href: `${baseURL}zh${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      { rel: 'alternate', hreflang: 'en', href: `${baseURL}en${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      { rel: 'alternate', hreflang: 'ja', href: `${baseURL}ja${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // x-default 指向英文版（国际通用回退）
      { rel: 'alternate', hreflang: 'x-default', href: `${baseURL}en${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // ── 待激活语言（在 nuxt.config.ts 中取消注释对应 locale 后，同步取消以下注释）──
      // 注意：itb 需改为标准 ISO 639-1 代码 it（意大利语），见 SEO-07
      // { rel: 'alternate', hreflang: 'ko', href: `${baseURL}ko${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'hi', href: `${baseURL}hi${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'ar', href: `${baseURL}ar${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'de', href: `${baseURL}de${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'fr', href: `${baseURL}fr${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'id', href: `${baseURL}id${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'it', href: `${baseURL}itb${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'uk', href: `${baseURL}uk${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
      // { rel: 'alternate', hreflang: 'zh-TW', href: `${baseURL}tw${finalPathPart}${queryPart ? `?${queryPart}` : ''}` },
     ],
     script: config && config.faqSchema ? [
      {
        type: 'application/ld+json',
        innerHTML: config.faqSchema
      }
    ] : [],
     htmlAttrs: {
      lang: lang
     }
   })
   useSeoStore().setSeoH1(config && config.h1 || '')
 }